import React from "react";

export const ChevronUpIcon = ({...props}) => {
  return (
    <>
      <path d="M0.372407386,18.5474131 C0.880692384,19.0832384 1.73135942,19.1006631 2.26024276,18.5874239 L2.26024276,18.5874239 L12.0250991,9.23453951 L21.7397779,18.493153 C22.2703313,19.0064092 23.1196069,18.9889845 23.6276133,18.4531422 C24.1390889,17.9209187 24.1217186,17.075374 23.5876025,16.5658641 L23.5876025,16.5658641 L12.9486962,6.37233322 C12.6914921,6.12353569 12.3591306,6 12.0250991,6 C11.6910675,6 11.3570359,6.17258332 11.0513975,6.47321141 L11.0513975,6.47321141 L0.412490394,16.6667423 C-0.121737065,17.1733555 -0.13910651,18.0195695 0.372407386,18.5474131 Z"></path>
    </>
  );
};
